export const otherAsset = {name: 'Other asset', id: 'other'}
